import * as React from 'react';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { WIZARD_COLORS } from '../../../components/FormComponents/dynamicForm';
import { formatFileSize, formatUploadTimestamp } from '../document_upload_service';
var UploadedDocumentCard = function (_a) {
    var uploadedDocument = _a.uploadedDocument, onRemove = _a.onRemove;
    var handleRemove = React.useCallback(function () { return onRemove(uploadedDocument); }, [onRemove, uploadedDocument]);
    var meta = React.useMemo(function () {
        var uploadedAt = formatUploadTimestamp(uploadedDocument.uploadedAt);
        return [
            formatFileSize(uploadedDocument.fileSize),
            uploadedAt ? "Uploaded ".concat(uploadedAt) : '',
        ]
            .filter(Boolean)
            .join(' • ');
    }, [uploadedDocument.fileSize, uploadedDocument.uploadedAt]);
    return (React.createElement(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            height: '100%',
            padding: '12px 14px',
            borderRadius: '8px',
            border: "1px solid ".concat(WIZARD_COLORS.border),
            backgroundColor: WIZARD_COLORS.surface,
        } },
        React.createElement(DescriptionIcon, { "aria-hidden": true, sx: { flexShrink: 0, fontSize: 30, color: WIZARD_COLORS.body } }),
        React.createElement(Box, { sx: { flex: 1, minWidth: 0 } },
            React.createElement(Tooltip, { title: uploadedDocument.fileName, placement: "top" },
                React.createElement(Typography, { noWrap: true, sx: { fontSize: 14, color: WIZARD_COLORS.ink } }, uploadedDocument.fileName)),
            uploadedDocument.docTypeLabel && (React.createElement(Typography, { noWrap: true, sx: { fontSize: 12, color: WIZARD_COLORS.muted } }, uploadedDocument.docTypeLabel)),
            meta && (React.createElement(Typography, { sx: { fontSize: 12, marginTop: '2px', color: WIZARD_COLORS.muted } }, meta))),
        React.createElement(Stack, { direction: "row", alignItems: "center", gap: 0.5, sx: { flexShrink: 0 } },
            React.createElement(CheckCircleIcon, { "aria-hidden": true, sx: { fontSize: 18, color: '#2E7D32' } }),
            React.createElement(IconButton, { size: "small", "aria-label": "Remove ".concat(uploadedDocument.fileName), onClick: handleRemove, sx: {
                    padding: '6px',
                    borderRadius: '6px',
                    color: WIZARD_COLORS.error,
                    backgroundColor: 'rgba(211,47,47,0.08)',
                    '&:hover': { backgroundColor: 'rgba(211,47,47,0.16)' },
                } },
                React.createElement(DeleteOutlineIcon, { sx: { fontSize: 18 } })))));
};
export default React.memo(UploadedDocumentCard);
